<template>
  <div class="row f-row justify-content-center" style="font-size: 0.9rem">
    <div class="col col-auto text-center" style="padding: 8px;">
      <div class="explain-process text-center" v-if="showExplanation">
        <img :src="logo" height="50" alt="" style="padding: 0" />
        <br />
        {{ txt }}
      </div>
      <div
        class="inh"
        style="width: 200px"
        v-bind:class="[
          processStage >= 0 && valuated
            ? 'process-ok bdr-r-h row-shadow'
            : 'process-pending bdr-r',
        ]"
        @mouseover="onHoverExplain(0)"
        @mouseleave="onHoverExplain(-1)"
      >
        1. DEFINE HEDGE
      </div>
      <div
        class="inh bdr-r"
        style="width: 200px"
        v-bind:class="[
          processStage >= 1
            ? 'process-ok bdr-r-h row-shadow'
            : 'process-pending bdr-r',
        ]"
        @mouseover="onHoverExplain(1)"
        @mouseleave="onHoverExplain(-1)"
      >
        2. RFQ
      </div>
      <div
        class="inh bdr-r"
        style="width: 200px"
        v-bind:class="[
          processStage >= 2 && readyToTrade
            ? 'process-ok bdr-r-h row-shadow'
            : 'process-pending bdr-r',
        ]"
        @mouseover="onHoverExplain(2)"
        @mouseleave="onHoverExplain(-1)"
      >
        3. SELECT COUNTERPARTY
      </div>
      <div
        class="inh bdr-r"
        style="width: 200px"
        v-bind:class="[
          processStage >= 3 && readyToTrade
            ? 'process-ok bdr-r-h row-shadow'
            : 'process-pending bdr-r',
        ]"
        @mouseover="onHoverExplain(3)"
        @mouseleave="onHoverExplain(-1)"
      >
        4. REFRESH QUOTE
      </div>
      <div
        class="inh bdr-r"
        style="width: 200px"
        v-bind:class="[
          processStage >= 4
            ? 'process-ok bdr-r-h row-shadow'
            : 'process-pending bdr-r',
        ]"
        @mouseover="onHoverExplain(4)"
        @mouseleave="onHoverExplain(-1)"
      >
        4. SEND ORDER
      </div>
      <div
        class="inh bdr-r"
        style="width: 200px"
        v-bind:class="[
          processStage >= 5
            ? 'process-ok bdr-r-h row-shadow'
            : 'process-pending bdr-r',
        ]"
        @mouseover="onHoverExplain(5)"
        @mouseleave="onHoverExplain(-1)"
      >
        5. SEND CONFIRMATION
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OverallProcess",
  props: {
    colorTheme: { required: true, type: Boolean, default: true },
    processStage: { required: true, default: 0 },
    readyToTrade: { required: true, type: Boolean, default: false },
    valuated: { required: true, default: false },
  },
  data() {
    return {
      txt: "...",
      showExplanation: false,
      logo: require("@/assets/images/symbol_white.svg"),
    };
  },
  mounted() {
    if (!this.colorTheme) {
      this.logo = require("@/assets/images/symbol_black.svg");
    }
  },
  watch: {
    colorTheme(val) {
      if (val) {
        this.logo = require("@/assets/images/symbol_white.svg");
      } else {
        this.logo = require("@/assets/images/symbol_black.svg");
      }
    },
  },
  methods: {
    onHoverExplain(val) {
      if (val === 0) {
        this.txt =
          "Select currency, position, dates, notional and strategy, then click REQUEST FOR QUOTE.";
      } else if (val === 1) {
        this.txt =
          "Wait for counterparties' quotes, then compare and select the counterparty you want to trade with.";
      } else if (val === 2) {
        this.txt = "Select counterparty and then click SEND ORDER.";
      } else if (val === 3) {
        this.txt =
          "Wait for the fill confirmation, check values and then Accept the hedge.";
      } else if (val === 4) {
        this.txt = "Hedge complete.";
      } else {
        this.txt = "";
      }
      this.showExplanation = val > -1;
    },
  },
};
</script>

<style scoped></style>
